module.exports = __webpack_public_path__ + "static/profile-24986226dd1c8e5782fc7c1ad20b3578.jpg";